import { render, staticRenderFns } from "./VoyageMap.vue?vue&type=template&id=6011ff68&scoped=true"
import script from "./VoyageMap.vue?vue&type=script&lang=js"
export * from "./VoyageMap.vue?vue&type=script&lang=js"
import style0 from "./VoyageMap.vue?vue&type=style&index=0&id=6011ff68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6011ff68",
  null
  
)

export default component.exports